import type {
  ChartType,
  MarketBarMessage,
  OhlcvPoint,
  PricePoint,
} from "~types/ticker-chart";

export function marketBarToChartPoint(
  message: MarketBarMessage,
  chartType: ChartType
): PricePoint | OhlcvPoint {
  const timestamp = new Date(message.datetime).getTime();

  if (!Number.isFinite(timestamp)) {
    throw new Error(
      `Invalid datetime in market bar message: ${message.datetime}`
    );
  }

  if (chartType === "candlestick") {
    return {
      timestamp,
      open: message.openPrice,
      high: message.highPrice,
      low: message.lowPrice,
      close: message.closePrice,
      volume: message.volume,
    };
  }

  return {
    timestamp,
    value: message.closePrice,
    volume: message.volume ?? 0,
  };
}
